import { useI18n } from 'vue-i18n'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fa } from 'vuetify/iconsets/fa'
import { aliases, md } from 'vuetify/iconsets/md'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

import { kidzonetDashboardIconSet } from '@kidzonet/dashboard-icons'
// @ts-expect-error strange import problems
import i18n from '@kidzonet/vue-i18n-package/obj.d.ts'
import theme from '@kidzonet/vuetify-config/isp-admin-theme'
import { defaultVuetifyComponentsStyle } from '@kidzonet/vuetify-config/vuetify'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

const kidzonetDashboardAliases = {
    Trash: 'delete',
}

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'kidzonetDashboardIconSet',
        aliases: {
            ...aliases,
            ...kidzonetDashboardAliases,
        },
        sets: {
            kidzonetDashboardIconSet,
            fa,
            md,
        },
    },
    locale: {
        // @ts-expect-error vuetify types
        adapter: createVueI18nAdapter({ i18n, useI18n }),
    },
    theme,
    defaults: defaultVuetifyComponentsStyle,
})
